var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" Hello there, this is the logout page. If you are stuck on this page, please contact support@qwips.no. ")])}
var staticRenderFns = []

export { render, staticRenderFns }